import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ContentEpisodes = styled.div`
  padding: 20px;
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
  .episode-item {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-bottom: 1px solid #EFEFF9;
    margin-bottom: 10px;
    .number {
      color: #1F1F52;
      font-family: Nunito Sans Bold;
      font-size: 20px;
      padding: 0 5px;
      margin-right: 10px;
    }
    .episode-data {
      .episode-title {
        font-family: Nunito Sans;
        font-size: 17px;
        margin-bottom: 10px;
      }
      .episode-description {
        font-family: Nunito Sans;
        font-size: 14px;
        color: #3E3E5B;
      }
    }
  }
`;